export default "__VITE_ASSET__BX4vaIOj__"